import { TFunction, UnsafeTFunction } from '../../i18next';

export const joinWithCommaAndAnd = (xs: string[], t: TFunction) => {
  let els = xs.slice();
  if (els.length > 2) {
    const lastEl = els.pop() || ''; // just to satisfy the type ssytem
    els = [els.join(', '), lastEl];
  }
  return els.join(` ${t('and')} `);
};

export const joinWithCommaAndOr = (xs: string[], t: UnsafeTFunction) => {
  let els = xs.slice();
  if (els.length > 2) {
    const lastEl = els.pop() || ''; // just to satisfy the type ssytem
    els = [els.join(', '), lastEl];
  }
  return els.join(` ${t('or')} `);
};
